import React from 'react';
import {  Form,Input,Button, Space,message,Divider } from 'antd';
import { hnrequest } from '@/utils'


const Sqdh = ({onsetHticks}) => {
  const [messageApi, contextHolderdh] = message.useMessage();
  const [paym] = Form.useForm();
  

  const onFinish = async (values) => {
   const res = await hnrequest.post('/p_sqdh', values)
   messageApi.open({
    type: res.return_code ,
    content: res.return_msg ,
})

setTimeout(() => { onsetHticks(res.ticks)}, 2000) 
    

  }
  return (
    <>
    {contextHolderdh}
    <Divider style={{ borderColor: '#7cb305' }}>胜券兑换</Divider>
      <Form
        name="paym"
        form={paym}
        onFinish={onFinish}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 400,
        }}
        initialValues={{
          remember: true,
        }}
        autoComplete="off"

      >
        <Form.Item
          label="兑换金额"
          name="dhamount"
        >
         <Space><Input  placeholder='请输入兑换金额'/><Button type="primary" htmlType="submit">兑换</Button></Space> 

        </Form.Item>


      </Form>
   
    </>
  )

}
export default Sqdh